import { createContext } from "react";

export const AuthContext = createContext({
  isLoggedIn: false,
  token: null,
  userId: null,
  username: null,
  role: null,
  isAdmin: false,
  isRoot: false,
  login: () => {},
  logout: () => {},
});
